// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"81":"47d2888f668e5f04aaaf","501":"5c0c6bbea083c310cb3d","540":"15a05daff105a0cf47e1","961":"ce71157ec6c5b89005f3"}[chunkId] + ".js";
};